(() => {
  const isWalkExploreSet = /\/products\/walk-explore-set\/?$/.test(window.location.pathname);
  if (!isWalkExploreSet) return;

  const applyFrame = () => {
    const visual = document.querySelector('[data-powlife-product] [data-story-panel="help"] .pl-help__visual');
    if (!visual || visual.classList.contains('pl-help__visual--walk-size-frame')) return;

    visual.classList.add('pl-help__visual--walk-size-frame');

    if (!document.getElementById('WalkSizeHelpFrameStyles')) {
      const style = document.createElement('style');
      style.id = 'WalkSizeHelpFrameStyles';
      style.textContent = `
        .pl-help__visual.pl-help__visual--walk-size-frame {
          display: grid !important;
          place-items: center !important;
          min-height: 720px !important;
          padding: 24px !important;
          background: #fff !important;
          overflow: visible !important;
        }
        .pl-help__visual.pl-help__visual--walk-size-frame img {
          width: 100% !important;
          height: 100% !important;
          max-width: 100% !important;
          max-height: 100% !important;
          object-fit: contain !important;
          object-position: center !important;
        }
        @media (max-width: 989px) {
          .pl-help__visual.pl-help__visual--walk-size-frame {
            min-height: 560px !important;
            padding: 18px !important;
          }
        }
        @media (max-width: 749px) {
          .pl-help__visual.pl-help__visual--walk-size-frame {
            min-height: 430px !important;
            aspect-ratio: auto !important;
            padding: 12px !important;
          }
        }
      `;
      document.head.appendChild(style);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFrame, { once: true });
  } else {
    applyFrame();
  }

  document.addEventListener('shopify:section:load', applyFrame);
})();